import { render, staticRenderFns } from "./Buyer.vue?vue&type=template&id=4fb82888"
import script from "./Buyer.vue?vue&type=script&lang=ts"
export * from "./Buyer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports